/* eGURU 28/09/2026 — THẺ SẢN PHẨM LƯỚT VÀO TỪ TRÁI SANG PHẢI khi cuộn tới (anh Thắng).
   Nhẹ: chỉ đổi transform + opacity (trình duyệt vẽ bằng GPU, không tính lại bố cục), ~1 KB, nạp defer.
   - Thẻ ĐANG nằm trong màn hình lúc mở trang: KHÔNG hiệu ứng (không làm chậm LCP, khách thấy ngay).
   - Thẻ cùng lượt hiện: xếp theo vị trí từ trái sang phải, mỗi thẻ trễ hơn thẻ trước 70 ms.
   - Máy bật "giảm chuyển động" hoặc trình duyệt thiếu IntersectionObserver: bỏ qua hoàn toàn.
   - Lưới/dải nạp thêm bằng AJAX (lọc, phân trang, gợi ý sản phẩm): MutationObserver bắt thẻ mới.
   CSS đi kèm ở cuối assets/custom-third-party.css (lớp the-cho / the-hien). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CHON = '.product-grid > .grid__item, .swiper-slide, .owl-item';
  var io = new IntersectionObserver(function (entries) {
    var hien = entries.filter(function (e) { return e.isIntersecting; })
      .sort(function (a, b) { return a.boundingClientRect.left - b.boundingClientRect.left; });
    hien.forEach(function (e, i) {
      var el = e.target;
      io.unobserve(el);
      el.style.transitionDelay = Math.min(i, 5) * 70 + 'ms';
      el.classList.add('the-hien');
      el.addEventListener('transitionend', function xong() {
        el.classList.remove('the-cho', 'the-hien');
        el.style.transitionDelay = '';
        el.removeEventListener('transitionend', xong);
      });
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function nhan(el) {
    if (el.dataset.theLuot) return;
    el.dataset.theLuot = '1';
    if (!el.querySelector('.card, .card-wrapper')) return; // chỉ thẻ sản phẩm, bỏ slide banner
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) return; // đang thấy sẵn → để yên
    el.classList.add('the-cho');
    io.observe(el);
  }
  function quet(goc) {
    (goc || document).querySelectorAll(CHON).forEach(nhan);
    // Owl/Swiper chạy vòng tự NHÂN BẢN thẻ: bản sao mang sẵn lớp the-cho + data-the-luot nhưng chưa được
    // theo dõi → kẹt ẩn. Theo dõi lại mọi thẻ còn chờ (observe lặp lại trên cùng phần tử là vô hại).
    document.querySelectorAll('.the-cho:not(.the-hien)').forEach(function (el) { io.observe(el); });
  }

  quet();
  var hen = null;
  new MutationObserver(function () {
    if (hen) return;
    hen = setTimeout(function () { hen = null; quet(); }, 200);
  }).observe(document.body, { childList: true, subtree: true });
})();

/* eGURU 29/09/2026 — DẢI CÓ NÚT TRÁI/PHẢI TỰ CHẠY (anh Thắng: "chuyển từng cái 1–2 giây; cái nào chuyển
   cả trang thì 3–4 giây cho khách đọc kịp; dò toàn theme").
   Chỉ lo các dải KHÔNG có sẵn chế độ tự chạy:
     - dải danh mục của agency (category-carousel, lật cả TRANG 4 ô + chấm)  → 3 s, hết trang thì về trang đầu
     - dải vuốt Dawn <slider-component> trên điện thoại (ô danh mục, bài viết…) → 1,2 s/thẻ, hết thì về đầu
   Các dải có sẵn tự chạy thì chỉnh ở chỗ của nó: Swiper "chuyên gia khuyên dùng" + Owl "Bạn cũng có thể thích"
   (2 s/thẻ, trong section), banner hero (4 s, cài đặt section), thanh thông báo (4 s, data-speed).
   CHỪA bộ ảnh sản phẩm. Dừng khi rê chuột / chạm / đang gõ, khi dải ra khỏi màn hình, khi tab bị ẩn;
   máy bật "giảm chuyển động" thì không chạy. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var coIO = 'IntersectionObserver' in window;

  function chay(goc, buoc, ms) {
    if (goc.dataset.tuChay) return;
    goc.dataset.tuChay = '1';
    var thay = !coIO, dung = 0;
    if (coIO) new IntersectionObserver(function (e) { thay = e[0].isIntersecting; }, { threshold: 0.3 }).observe(goc);
    function nghi(t) { dung = Date.now() + t; }
    goc.addEventListener('mouseenter', function () { nghi(864e5); });
    goc.addEventListener('mouseleave', function () { dung = 0; });
    goc.addEventListener('touchstart', function () { nghi(6000); }, { passive: true });
    goc.addEventListener('focusin', function () { nghi(864e5); });
    goc.addEventListener('focusout', function () { dung = 0; });
    setInterval(function () {
      if (!thay || document.hidden || Date.now() < dung || !goc.isConnected) return;
      buoc();
    }, ms);
  }

  function quet() {
    // 1) dải danh mục agency: lật trang
    document.querySelectorAll('[id^="CategoryCarousel-"]').forEach(function (s) {
      var next = s.querySelector('[data-carousel-next]');
      var dau = s.querySelector('[data-carousel-dot]');
      if (!next) return;
      chay(s, function () {
        if (next.disabled) { if (dau) dau.click(); } else next.click();
      }, 3000);
    });
    // 2) dải vuốt Dawn: từng thẻ (chừa ảnh sản phẩm)
    document.querySelectorAll('slider-component').forEach(function (sc) {
      if (sc.closest('media-gallery, .product__media-wrapper, [id^="GalleryViewer"], .product__media-list')) return;
      var sl = sc.querySelector('.slider'), next = sc.querySelector('.slider-button--next');
      if (!sl || !next) return;
      if (sl.scrollWidth <= sl.clientWidth + 8) return;              // không tràn = không phải dải trượt (vd máy tính)
      if (getComputedStyle(next).display === 'none') return;
      chay(sc, function () {
        if (sl.scrollWidth <= sl.clientWidth + 8) return;
        var cuoi = sl.scrollLeft + sl.clientWidth >= sl.scrollWidth - 8;
        if (cuoi || next.disabled) sl.scrollTo({ left: 0, behavior: 'smooth' }); else next.click();
      }, 1200);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quet); else quet();
  window.addEventListener('load', quet);
  document.addEventListener('shopify:section:load', quet);
})();
